import EventDispatcher from '@/base/event/event-dispatcher';
import $ from 'jquery';
import tmpl from './tmpl/_pager.art';
import './tmpl/pager.scss';

/**
 * 分页器
 */
class Pager extends EventDispatcher {
    /*
     * 根据索引获取元素
     * @param { Object } options 分页相关参数
         current: 当前页码
         total: 总页数
     * @param { $parent } 父级dom元素
     */
    constructor(options, $parent) {
        super();
        this.$parent = $parent || $('body'); // 当前元素
        this.options = options || {};
        this.render();
    }

    render() {
        this.$el = $(tmpl(this.options));
        this.$parent.append(this.$el);
        this.$num = this.$el.find('.num');
        return this;
    }

    /*
     * 更新当关页码
     * @param { Number } current 当前页码
     * @param { Number } total 总页数
     */
    update(current, pageCount) {
        this.$num.text(`${current}/${this.options.total}`);
        return this;
    }

    show() {
        this.$el.removeClass('hide').addClass('show');
        return this;
    }

    hide() {
        this.$el.removeClass('show').addClass('hide');
        return this;
    }
}

export default Pager;